import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import store from './store'
import * as echarts from 'echarts' // echarts
import './plugins/element.js' // 按需引入的elementui
import './assets/css/base.css' // 基本通用样式
import './assets/css/pluginbase.css' // 自定义的通用样式
import './assets/css/fonts.css' // 自定义的字体
import '/src/css/layui/css/layui.css';
import 'default-passive-events'
import dataV from '@jiaminghi/data-view' // dataV可视化插件
import scroll from 'vue-seamless-scroll' // 无缝滚动插件
import animated from 'animate.css' // animate.css插件

import router from './router'

// 自定义全局年份选择器组件
import YearSelect from './components/year_select/YearSelect.vue'
Vue.component('YearSelect',YearSelect)

Vue.use(ElementUI);
Vue.use(animated)
Vue.prototype.$echarts = echarts
Vue.use(dataV)
Vue.use(scroll)
Vue.config.productionTip = false
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
